var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88753 1.39283L2.94163 3.31598L8.74837 3.34251C8.83722 3.34284 8.92514 3.36069 9.00708 3.39504C9.08903 3.42938 9.1634 3.47955 9.22593 3.54268C9.28847 3.6058 9.33794 3.68063 9.37152 3.76289C9.4051 3.84516 9.42213 3.93324 9.42163 4.02209V4.02209C9.42122 4.11089 9.40331 4.19874 9.36892 4.28061C9.33454 4.36248 9.28436 4.43678 9.22124 4.49925C9.15813 4.56171 9.08332 4.61113 9.0011 4.64467C8.91888 4.67821 8.83085 4.69522 8.74205 4.69472L2.93658 4.66883L4.85658 6.61156C4.91916 6.67457 4.96871 6.7493 5.00239 6.83147C5.03607 6.91364 5.05322 7.00165 5.05287 7.09045C5.05252 7.17926 5.03467 7.26712 5.00034 7.34903C4.966 7.43093 4.91587 7.50526 4.85279 7.56777V7.56777C4.72526 7.69396 4.55286 7.76437 4.37345 7.76354C4.19405 7.76271 4.02231 7.69071 3.89595 7.56335L0.738053 4.37451C0.634792 4.26956 0.577447 4.1279 0.578631 3.98068C0.579816 3.83345 0.639433 3.69273 0.744369 3.58946L3.93574 0.431562C4.06316 0.305414 4.23546 0.235018 4.41476 0.235847C4.59406 0.236676 4.7657 0.308662 4.89195 0.435983V0.435983C4.95451 0.499089 5.00402 0.573902 5.03765 0.656149C5.07129 0.738395 5.08839 0.826463 5.08798 0.91532C5.08757 1.00418 5.06965 1.09208 5.03526 1.17402C5.00087 1.25595 4.95067 1.3303 4.88753 1.39283Z",
    fill: "rgb(var(--gray))"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.0f39c19667d452cac3978038787f6fb7.svg";
export { ForwardRef as ReactComponent };